import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { strRemaining } from './string-util';

export const RemainingCharsHint = ({
  str, i18n, schema, newI18n,
}) => (
  schema.maxLength && _.isString(str) ?
    (<div className="remaining-hint help-block">{strRemaining(i18n, str, schema, newI18n)}</div>) : null);

RemainingCharsHint.propTypes = {
  str: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
  schema: PropTypes.shape({
    maxLength: PropTypes.number,
  }).isRequired,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
};

RemainingCharsHint.defaultProps = {
  str: undefined,
  i18n: undefined,
  newI18n: undefined,
};
